var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01594 8.28313V9.10387C7.01594 9.98557 5.94012 10.4277 5.30977 9.8051L1.70992 6.24935C1.31815 5.86237 1.31815 5.23386 1.70992 4.84689L5.30977 1.29113C5.94011 0.668504 7.01594 1.11066 7.01594 1.99236V4.55774C7.01594 5.10471 7.46365 5.54812 8.01594 5.54812H21M14.9841 18.1869V19.0076C14.9841 19.8893 16.0599 20.3315 16.6902 19.7089L20.2901 16.1531C20.6819 15.7661 20.6819 15.1376 20.2901 14.7507L16.6902 11.1949C16.0599 10.5723 14.9841 11.0144 14.9841 11.8961V14.4615C14.9841 15.0085 14.5363 15.4519 13.9841 15.4519H1",
    stroke: "#11334E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStationIcon);
export default __webpack_public_path__ + "static/media/changeStationIcon.44dc22d575082b13ae2eabcdf875d6af.svg";
export { ForwardRef as ReactComponent };